/* TODO: fix this: consider to merge / generalize this with "Sidebar"
 * Lots of the features of this component are similar to the
 * features of component "Sidebar" */

import React from 'react';
import PropTypes from 'prop-types';
import { manageEventListener, handleElementCloserEvents } from '../../../common/utils';
import withLocalization from '../../higherOrderComponents/withLocalization';
import { Button } from '../ActionElement';

class CollapsibleMobileMenuController extends React.Component {
  constructor(props) {
    super(props);
    const { isMenuExpanded = false } = props;
    this.state = { isMenuExpanded };
    this.clickAreaClassName = 'collapsible-mobile-menu-wrap';
    this.toggleMenu = this.toggleMenu.bind(this);
    this.manageEventListeners = this.manageEventListeners.bind(this);
    this.handleClickEvent = this.manageEventListeners.bind(this);
    this.handleKeyUpEvent = this.manageEventListeners.bind(this);
  }

  componentDidMount() {
    this.manageEventListeners('add');
  }

  componentWillUnmount() {
    this.manageEventListeners('remove');
  }

  toggleMenu(isMenuExpanded) {
    this.setState(actualState => {
      if (actualState.isMenuExpanded !== isMenuExpanded) {
        return {
          isMenuExpanded: typeof (isMenuExpanded) !== 'undefined'
            ? isMenuExpanded
            : !actualState.isMenuExpanded
        };
      }
    });
  }

  manageEventListeners(action) {
    const { handleCloserEvent } = this;

    ['click', 'keyup'].forEach(eventType => manageEventListener(
      document,
      eventType,
      action,
      handleCloserEvent
    ));
  }

  handleSidebarCloserEvent(event) {
    const { toggleMenu, clickAreaClassName } = this;
    const closeMenu = () => toggleMenu(false);
    handleElementCloserEvents(event, `.${clickAreaClassName}`, closeMenu);
  }

  render() {
    const {
      props,
      state,
      clickAreaClassName,
      toggleMenu
    } = this;

    const {
      menuId,
      children,
      translate
    } = props;

    const { isMenuExpanded } = state;

    const classNames = [clickAreaClassName];

    if (isMenuExpanded) {
      classNames.push('expanded');
    }

    return (
      <div className={classNames.join(' ')}>
        <Button
          onClick={() => toggleMenu()}
          iconName={isMenuExpanded ? 'times' : 'bars'}
          appearance='buttonOutline'
          buttonColor='white'
          className='button-toggler'
          title={translate('button-toggler-title')}
          aria-expanded={isMenuExpanded}
          ariaControls={menuId}
          disabled={false}
        />

        {children}
      </div>
    );
  }
}

CollapsibleMobileMenuController.propTypes = {
  menuId: PropTypes.string.isRequired,
  isMenuExpanded: PropTypes.bool
};

export default withLocalization(CollapsibleMobileMenuController, 'elements/menu');